import { render, staticRenderFns } from "./MenuFormFilters.vue?vue&type=template&id=02266856"
import script from "./MenuFormFilters.vue?vue&type=script&lang=js"
export * from "./MenuFormFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports